module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.pages < _vm.maxPages) ? _c('div', [_c('button', {
    class: _vm.vspbutton + (_vm.vspbuttonfast !== '' ? ' ' + _vm.vspbuttonfast : ''),
    on: {
      "click": function($event) {
        return _vm.handlePageChange(0)
      }
    }
  }, [_vm._v(" <<")]), _vm._v(" "), _vm._l((_vm.pages), function(item) {
    return _c('button', {
      key: item,
      class: _vm.vspbutton + (item - 1 == _vm.currPage ? ' ' + _vm.vspbuttonselected : ''),
      on: {
        "click": function($event) {
          return _vm.handlePageChange(item - 1)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), _c('button', {
    class: _vm.vspbutton + (_vm.vspbuttonfast !== '' ? ' ' + _vm.vspbuttonfast : ''),
    on: {
      "click": function($event) {
        return _vm.handlePageChange(_vm.pages - 1)
      }
    }
  }, [_vm._v(">>")])], 2) : _c('div', [_c('button', {
    class: _vm.vspbutton + (_vm.vspbuttonfast !== '' ? ' ' + _vm.vspbuttonfast : ''),
    on: {
      "click": function($event) {
        return _vm.handlePageChange(0)
      }
    }
  }, [_vm._v(" <<")]), _vm._v(" "), _vm._l((_vm.leftPages), function(item) {
    return _c('button', {
      key: item,
      class: _vm.vspbutton + (item - 1 == _vm.currPage ? ' ' + _vm.vspbuttonselected : ''),
      on: {
        "click": function($event) {
          return _vm.handlePageChange(item - 1)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), ((_vm.pages - 4) - _vm.currPage > 3) ? _c('span', [_vm._v("...")]) : _vm._e(), _vm._v(" "), _vm._l(([_vm.pages - 4, _vm.pages - 3, _vm.pages - 2, _vm.pages - 1, _vm.pages]), function(item) {
    return _c('button', {
      key: item,
      class: _vm.vspbutton + (item - 1 == _vm.currPage ? ' ' + _vm.vspbuttonselected : ''),
      on: {
        "click": function($event) {
          return _vm.handlePageChange(item - 1)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), _c('button', {
    class: _vm.vspbutton + (_vm.vspbuttonfast !== '' ? ' ' + _vm.vspbuttonfast : ''),
    on: {
      "click": function($event) {
        return _vm.handlePageChange(_vm.pages - 1)
      }
    }
  }, [_vm._v(">>")])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55c399c3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/simple-pagination.vue
// module id = 716
// module chunks = 1